export const SECCION_ART = 2;
export const SECCION_HIPOTECA = 8;
export const SECCION_RESPONSABILIDAD_CIVIL = 9;

/** ART y RC exigen y persisten posibilidad de cierre. */
export const SECCIONES_CON_POSIBILIDAD_CIERRE = [
   SECCION_ART,
   SECCION_RESPONSABILIDAD_CIVIL,
];

/** ART / Hipoteca / RC muestran bloque de referente opcional. */
export const SECCIONES_CON_REFERENTE = [
   SECCION_ART,
   SECCION_HIPOTECA,
   SECCION_RESPONSABILIDAD_CIVIL,
];

export const seccionUsaPosibilidadCierre = (id) =>
   SECCIONES_CON_POSIBILIDAD_CIERRE.includes(Number(id));

export const seccionUsaReferente = (id) =>
   SECCIONES_CON_REFERENTE.includes(Number(id));
